//Swiper JS
import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import { Navigation } from "swiper/modules";
// import { Virtual } from "swiper/modules";
import { Keyboard } from "swiper/modules";
// import { Mousewheel } from "swiper/modules";
import { Pagination } from "swiper/modules";
// import { Scrollbar } from "swiper/modules";
// import { Parallax } from "swiper/modules";
// import { FreeMode } from "swiper/modules";
// import { Grid } from "swiper/modules";
// import { Manipulation } from "swiper/modules";
// import { Zoom } from "swiper/modules";
// import { Controller } from "swiper/modules";
import { A11y } from "swiper/modules";
// import { History } from "swiper/modules";
// import { HashNavigation } from "swiper/modules";
import { EffectFade } from "swiper/modules";
// import { EffectCube } from "swiper/modules";
// import { EffectFlip } from "swiper/modules";
import { EffectCoverflow } from "swiper/modules";
import { EffectCards } from "swiper/modules";
// import { EffectCreative } from "swiper/modules";
// import { Thumbs } from "swiper/modules";
Swiper.use([
    Autoplay,
    Navigation,
    EffectFade,
    EffectCoverflow,
    EffectCards,
    Pagination,
    Keyboard,
    A11y,
]);
// Swiper CSS
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/a11y";
// import "swiper/css/controller";
import "swiper/css/effect-cards";
import "swiper/css/effect-coverflow";
// import "swiper/css/effect-creative";
// import "swiper/css/effect-cube";
import "swiper/css/effect-fade";
// import "swiper/css/effect-flip";
// import "swiper/css/free-mode";
// import "swiper/css/grid";
// import "swiper/css/hash-navigation";
// import "swiper/css/history";
import "swiper/css/keyboard";
// import "swiper/css/manipulation";
// import "swiper/css/mousewheel";
import "swiper/css/pagination";
// import "swiper/css/parallax";
// import "swiper/css/scrollbar";
// import "swiper/css/thumbs";
// import "swiper/css/virtual";
// import "swiper/css/zoom";
addEventListener("DOMContentLoaded", (event) => {
    const swiper = new Swiper(".sectionSlider", {
        effect: "fade",
        speed: 1000,
        autoplay: {
            delay: 10000,
            disableOnInteraction: false,
        },
    });
    document.querySelectorAll(".logo-slider").forEach((slider) => {
        let el = slider;
        const slidesPerView = parseInt(el.dataset.swiperSlidesperview) || 3;
        new Swiper(el, {
            slidesPerView: 1,
            centeredSlides: true,
            loop: true,
            speed: 500,
            keyboard: {
                enabled: true,
            },
            autoplay: {
                delay: 7000,
                disableOnInteraction: false,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: slidesPerView,
                },
            },
        });
    });
    document.querySelectorAll(".testimonial-slider").forEach((slider) => {
        let el = slider;
        const slidesPerView = parseInt(el.dataset.swiperSlidesperview) || 3;
        new Swiper(el, {
            slidesPerView: 1,
            loop: true,
            keyboard: {
                enabled: true,
            },
            spaceBetween: 50,
            speed: 500,
            autoplay: {
                delay: 12000,
                disableOnInteraction: false,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: slidesPerView,
                },
            },
            navigation: {
                nextEl: ".testimonial-swiper-button-next",
                prevEl: ".testimonial-swiper-button-prev",
            },
        });
    });
    document.querySelectorAll(".card-link-slider").forEach((slider) => {
        let el = slider;
        const slidesPerView = parseInt(el.dataset.swiperSlidesperview) || 3;
        new Swiper(el, {
            slidesPerView: 1,
            loop: true,
            keyboard: {
                enabled: true,
            },
            spaceBetween: 50,
            speed: 500,
            autoplay: {
                delay: 12000,
                disableOnInteraction: false,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: slidesPerView,
                },
            },
            navigation: {
                nextEl: ".card-link-swiper-button-next",
                prevEl: ".card-link-swiper-button-prev",
            },
        });
    });
    document.querySelectorAll(".image-carousel").forEach((slider) => {
        let el = slider, imagesPerSlideVal = parseInt(el.dataset.imagesPerSlide), navigationVal, paginationVal, autoHeightVal = el.dataset.autoheight === "1" ? true : false, autoPlayVal, styleVal = el.dataset.style ? el.dataset.style : "slide", speedVal = el.dataset.speed ? parseFloat(el.dataset.speed) : 10;
        if (el.dataset.navigation) {
            navigationVal = {
                nextEl: ".image-carousel-swiper-button-next",
                prevEl: ".image-carousel-swiper-button-prev",
            };
        }
        else {
            navigationVal = false;
        }
        if (el.dataset.autoplay) {
            autoPlayVal = {
                delay: speedVal * 1000,
                disableOnInteraction: false,
            };
        }
        else {
            autoPlayVal = false;
        }
        if (el.dataset.pagination) {
            paginationVal = {
                el: ".image-carousel-swiper-pagination",
                clickable: true,
            };
        }
        else {
            paginationVal = false;
        }
        new Swiper(el, {
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerView: imagesPerSlideVal,
                },
            },
            loop: true,
            spaceBetween: 35,
            speed: 500,
            effect: styleVal,
            keyboard: {
                enabled: true,
            },
            a11y: {
                enabled: true,
            },
            autoplay: autoPlayVal,
            navigation: navigationVal,
            pagination: paginationVal,
            autoHeight: autoHeightVal,
        });
    });
});
